import { useState, useEffect, useCallback } from "react";
import { useThemedLayoutContext } from "@refinedev/mui";

const SIDEBAR_COLLAPSED_KEY = "safee_sidebar_collapsed";

/**
 * Hook personnalisé pour gérer l'état collapsed de la sidebar avec persistence localStorage.
 */
export const useSidebarCollapsed = () => {
  // Lire la valeur initiale depuis localStorage
  const getStoredValue = (): boolean => {
    try {
      const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
      return saved === "true";
    } catch {
      return false;
    }
  };

  const initialValue = getStoredValue();

  const [collapsed, setCollapsedState] = useState<boolean>(initialValue);
  const { setSiderCollapsed } = useThemedLayoutContext();

  // Fonction pour changer l'état et persister
  const setCollapsed = useCallback((value: boolean) => {
    setCollapsedState(value);
    // Sauvegarder dans localStorage
    try {
      localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(value));
    } catch {
      // Silently ignore localStorage errors
    }
    // Synchroniser avec le contexte Refine
    setSiderCollapsed(value);
  }, [setSiderCollapsed]);

  // Synchroniser l'état initial avec Refine au montage
  useEffect(() => {
    setSiderCollapsed(collapsed);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Seulement au montage

  return { collapsed, setCollapsed };
};
